'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _odataFilterBuilder = require('odata-filter-builder');

var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);

var _query = require('utilities/query');

var _ingredientAutocomplete = require('./ingredient-autocomplete.html');

var _ingredientAutocomplete2 = _interopRequireDefault(_ingredientAutocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _ingredientAutocomplete2.default,
  bindings: {
    ingredientType: '@',
    labelText: '@',
    companyId: '<',
    searchText: '<',
    selectedIngredient: '<',
    searchDisplayProperty: '@',
    onIngredientSelected: '&'
  },
  controller: function () {
    function IngredientAutocomplete($log, EventEmitter, IngredientService) {
      'ngInject';

      _classCallCheck(this, IngredientAutocomplete);

      Object.assign(this, {
        $log: $log,
        EventEmitter: EventEmitter,
        IngredientService: IngredientService
      });
    }

    _createClass(IngredientAutocomplete, [{
      key: 'searchIngredients',
      value: function searchIngredients(name) {
        if (!this.ingredientType) {
          this.$log.error('Required ingredientType parameter not supplied for ingredient autocomplete!');
          return Promise.resolve(false);
        }

        if (this.ingredientType === 'system') {
          return this.searchSystemIngredients(name);
        }

        return this.searchUserIngredients(name);
      }
    }, {
      key: 'searchUserIngredients',
      value: function searchUserIngredients(name) {
        return this.IngredientService.searchUserIngredients(_extends({}, this.IngredientService.getDefaultUserIngredientQuery(), {
          filter: (0, _odataFilterBuilder2.default)().and(function (x) {
            return x.contains('UserIngredientName', name);
          })
        })).then(function (r) {
          return (0, _query.transformODataResponse)(r).Data;
        });
      }
    }, {
      key: 'searchSystemIngredients',
      value: function searchSystemIngredients(name) {
        return this.IngredientService.searchSystemIngredients(_extends({}, this.IngredientService.getDefaultSystemIngredientQuery(), {
          filter: (0, _odataFilterBuilder2.default)().and(function (x) {
            return x.contains('SystemIngredientName', name);
          })
        })).then(function (r) {
          return (0, _query.transformODataResponse)(r).Data;
        });
      }
    }, {
      key: 'selectedIngredientChanged',
      value: function selectedIngredientChanged(selectedIngredient) {
        this.onIngredientSelected(this.EventEmitter({
          selectedIngredient: selectedIngredient
        }));
      }
    }]);

    return IngredientAutocomplete;
  }()
};


// WEBPACK FOOTER //
// ./components/app/common/autocomplete/ingredient/ingredient-autocomplete.component.js